import { EventReport } from "@dashboard/devices/types";
import { Typography } from "@mui/material";
import { CollapsibleDetails, CollapsibleRow, CollapsibleSummary } from "@shared/table/CollapsibleRow";
import { flexRender, Row } from "@tanstack/react-table";

import { useStyles } from "./AdminEventsPage.style";

type EventRowProps = {
    row: Row<EventReport>;
};

const EventRow = ({ row }: EventRowProps) => {
    const { classes } = useStyles();

    return (
        <CollapsibleRow>
            <CollapsibleSummary row={row}>
                {row
                    .getVisibleCells()
                    .map((cell) => flexRender(cell.column.columnDef.cell, { ...cell.getContext(), key: cell.id }))}
            </CollapsibleSummary>
            <CollapsibleDetails>
                <Typography component="pre" className={classes.dataPayload}>
                    {row.original.data ? JSON.stringify(row.original.data, null, 2) : "-"}
                </Typography>
            </CollapsibleDetails>
        </CollapsibleRow>
    );
};

export default EventRow;
